export default function HeroSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-[620px] md:min-h-[680px] flex items-center bg-background-950 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20warm%20golden%20atmosphere%20with%20abstract%20film%20reel%20textures%20and%20soft%20dramatic%20spotlights%2C%20elegant%20dark%20theater%20curtains%20in%20deep%20coral%20red%2C%20luxurious%20movie%20premiere%20ambiance%2C%20rich%20amber%20and%20warm%20bronze%20tones%2C%20artistic%20photography%20style%2C%20sophisticated%20composition%2C%20no%20text%20no%20people&width=1600&height=900&seq=hero-6080-bg&orientation=landscape"
          alt="6080新视觉影视 - 影院级视觉体验背景"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/65"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 max-w-6xl mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/10 backdrop-blur-sm border border-background-50/15 mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-medium text-background-50/90">超清画质</span>
              <span className="text-background-50/30">·</span>
              <span className="text-xs font-medium text-background-50/90">蓝光播放</span>
              <span className="text-background-50/30">·</span>
              <span className="text-xs font-medium text-background-50/90">免费观影</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight">
              6080新视觉影视
              <span className="block text-primary-400 text-xl md:text-2xl lg:text-3xl mt-2 font-normal">
                高清电影在线观看平台
              </span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-background-200/80 font-medium">
              畅享视觉盛宴，发现光影之美
            </p>

            <p className="mt-5 text-sm md:text-base text-background-200/65 leading-relaxed max-w-xl mx-auto lg:mx-0">
              6080新视觉影视致力于打造极致的高清电影在线观看体验。平台收录海量影片资源，覆盖全球热门影视内容，
              每日动态更新片库。从经典老片到最新院线，从动作巨制到文艺佳作，无需注册即可免费在线观看。
              采用蓝光播放引擎与智能码率自适应技术，无论电脑、平板还是手机，都能享受流畅的超清画质观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 mt-6">
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400 text-base"></i>
                <span className="text-sm text-background-200/80">每日更新 · 片源丰富</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-4k-line text-accent-400 text-base"></i>
                <span className="text-sm text-background-200/80">超清画质 · 蓝光体验</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-accent-400 text-base"></i>
                <span className="text-sm text-background-200/80">完全免费 · 无需注册</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#ranking"
                onClick={(e) => { e.preventDefault(); handleScroll('#ranking'); }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#features"
                onClick={(e) => { e.preventDefault(); handleScroll('#features'); }}
                className="inline-flex items-center gap-2 px-7 py-3 rounded-lg bg-background-50/10 hover:bg-background-50/20 border border-background-50/20 text-background-50 font-medium text-sm whitespace-nowrap transition-colors cursor-pointer"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20cinematic%20composition%20with%20warm%20golden%20film%20strip%20motif%2C%20soft%20dramatic%20spotlight%20on%20rich%20theater%20textures%2C%20artistic%20abstract%20movie%20visual%20with%20amber%20and%20deep%20coral%20accents%2C%20luxurious%20cinema%20aesthetic%2C%20sophisticated%20warm%20atmosphere%2C%20high%20detail%2C%20no%20people&width=700&height=800&seq=hero-6080-visual&orientation=portrait"
                alt="6080新视觉影视主视觉 - 高清电影视觉盛宴"
                className="w-full h-auto object-cover rounded-xl"
              />
              <div className="absolute inset-0 rounded-xl ring-1 ring-inset ring-background-50/8"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}